import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/custom/List.svg?react
const SvgList = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M18.498 14V16H5.49805V14H18.498ZM18.498 11H5.49805V16L5.29395 15.9893C4.35239 15.8938 3.60425 15.1457 3.50879 14.2041L3.49805 14V11C3.49805 9.89543 4.39348 9 5.49805 9H18.498C19.6026 9 20.498 9.89543 20.498 11V14C20.498 15.0357 19.7108 15.887 18.7021 15.9893L18.498 16V11Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M19.498 5C20.0503 5 20.498 5.44772 20.498 6C20.498 6.55228 20.0503 7 19.498 7H4.49805C3.94576 7 3.49805 6.55228 3.49805 6C3.49805 5.44772 3.94576 5 4.49805 5H19.498Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M19.498 18C20.0503 18 20.498 18.4477 20.498 19C20.498 19.5523 20.0503 20 19.498 20H4.49805C3.94576 20 3.49805 19.5523 3.49805 19C3.49805 18.4477 3.94576 18 4.49805 18H19.498Z",
	fill: "currentColor"
}));

//#endregion
//#region src/icons/ListIcon.tsx
function ListIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgList,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { ListIcon as t };
//# sourceMappingURL=ListIcon-B7wSbR6v.js.map